import styled from "styled-components";

export const SelectedRowsButtonsContainer = styled.div`
  display: flex;
  margin-left: 10px;

  .whatsapp-btn {
    background-color: #72ae56;
    border: #72ae56;
  }

  .sms-btn {
    background-color: #d99f2d;
    border: #d99f2d;
  }

  .delete-btn {
    background-color: #f04c4c;
    border: #f04c4c;
  }
`;

export const WhatsAppContainer = styled.div`
  .customTextArea {
    width: 100%;
    padding-right: 30px;
    border-color: #c3c3c5;
    height: 100px;
  }
`;
